import React from 'react';
import { withTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';
import Button from './button';
import { cardBrandsCardknox } from '../global-props';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IField, { CARD_TYPE, CVV_TYPE } from '@cardknox/react-ifields';
import packageJson from '../../../package.json';
global.appVersion = packageJson.version;

class CardknoxCardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exp: "",
      cardBrand: null,
      loadedCard: false,
      loadedCVV: false,
      canContinue: false,
      account: {
        xKey: this.props.settings.ccProcessorPublicKey.value,
        xSoftwareName: "Mikvah RSVP",
        xSoftwareVersion: global.appVersion
      },
      iFieldstyle: {
        width: '95%',
        fontSize: '16px',
        border: 'none',
        outline: 'none'
      }
    }
    this.onToken = this.onToken.bind(this);
    this.onTokenError = this.onTokenError.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onUpdateCVV = this.onUpdateCVV.bind(this);
    this.displayField = this.displayField.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const target = e.target;
    const name = target.name;
    let value = target.value;
    const { exp } = this.state;
    if(name=='exp'){
      if((exp.length==1&&value.length==2)||(exp.length==2&&value.length==3)){
        value = value.slice(0, 2) + "/" + value.slice(2);
      } else if(exp.length==4&&value.length==3){
        value = value.slice(0,2);
      } else if(exp.length==4&&value.length==5){
        this.iFieldCvvRef.current.focusIfield();
        this.setState({expComplete: true});
        if(this.props.handleCanContinue && this.state.cardComplete && this.state.cvvComplete){
          this.props.handleCanContinue(true);
          if(this.props.handleCardComplete){
            this.props.handleCardComplete(true);
          }
        }
      }
    }
    if(value.length<=5){
      this.setState({[name]: value});
    }
    if(value.length<5){
      if(this.props.handleCardComplete){
        this.props.handleCardComplete(false);
      }
    }
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
    if(this.props.handleIsLoading){
      this.props.handleIsLoading(true);
    }
    this.setState({
      cvvToken: null,
      cardToken: null
    }, () => {
      this.iFieldCardRef.current.getToken();
    })
  }

  onToken(token){
    if(token.xTokenType=="card"){
      this.setState({cardToken: token, cardTokenError: null},()=>this.iFieldCvvRef.current.getToken())
    } else if(token.xTokenType=="cvv"){
      this.setState({cvvToken: token, cvvTokenError: null}, ()=> {
        if(this.state.cvvToken && this.state.cardToken){
            this.props.onGetToken({cardToken: this.state.cardToken, cvvToken: this.state.cvvToken, expiration: this.state.exp});
          }
      })
    }
  }

  onTokenError(error){
    if(this.props.handleIsLoading){
      this.props.handleIsLoading(false);
    }
    if(error.xTokenType=="card"){
      this.setState({cardTokenError: error.errorMessage})
    } else if(error.xTokenType=="cvv"){
      this.setState({cvvTokenError: error.errorMessage})
    }
  }

  displayField(type){
    if(type=='card'){
      setTimeout(() => this.setState({loadedCard: true}),10);
    } else{
      setTimeout(() => this.setState({loadedCVV: true}),10);
    }
  }

  onUpdate(data){
    if(data.event=='input'){
      if(this.props.onUpdate){
        this.props.onUpdate();
      }
      this.setState({
        cardBrand: ['visa','mastercard','discover','amex'].includes(data.issuer)?data.issuer:null
      })
      switch (data.issuer) {
        case 'visa':
        case 'mastercard':
        case 'discover':
          if(data.cardNumberLength>=16){
            if(data.isValid){
              this.expInput.current.focus();
              this.setState({cardComplete: true, cardError: false});
              if(this.state.cvvComplete && this.state.expComplete){
                if(this.props.handleCanContinue){
                  this.props.handleCanContinue(true);
                }
                if(this.props.handleCardComplete){
                  this.props.handleCardComplete(true);
                }      
                this.setState({canContinue: true});
              }    
            } else{
              this.setState({cardError: true, canContinue: false});
              if(this.props.handleCardComplete){
                this.props.handleCardComplete(false);
              }    
            }
          } else {
            if(this.props.handleCardComplete){
              this.props.handleCardComplete(false);
            }  
          }
        break
        case 'amex':
          if(data.cardNumberLength>=15){
            if(data.isValid){
              this.expInput.current.focus();
              this.setState({cardComplete: true, cardError: false});
              if(this.state.cvvComplete && this.state.expComplete){
                if(this.props.handleCanContinue){
                  this.props.handleCanContinue(true);
                }
                if(this.props.handleCardComplete){
                  this.props.handleCardComplete(true);
                }      
                this.setState({canContinue: true});
              }    
            } else{
              this.setState({cardError: true, canContinue: false});
              if(this.props.handleCardComplete){
                this.props.handleCardComplete(false);
              }    
            }
          } else {
            if(this.props.handleCardComplete){
              this.props.handleCardComplete(false);
            }  
          }
        break
      }
    }
  }

  onUpdateCVV(data){
    if(data.event=='input'){
      if(data.length>=3){
        this.setState({cvvComplete: true});
        if(this.state.cardComplete && this.state.expComplete){
          if(this.props.handleCanContinue){
            this.props.handleCanContinue(true);
          }
          if(this.props.handleCardComplete){
            this.props.handleCardComplete(true);
          }
          this.setState({canContinue: true});
        } else{
          if(this.props.handleCardComplete){
            this.props.handleCardComplete(false);
          }
        }
      } else {
        if(this.props.handleCardComplete){
          this.props.handleCardComplete(false);
        }
      }
    }
  }

  iFieldCardRef = React.createRef();
  iFieldCvvRef = React.createRef();
  expInput = React.createRef();
  render() {
    const { t, isLoading, inlineForm, formRef } = this.props;
    const { loadedCard, loadedCVV, exp, cardBrand, cardError, cardTokenError, cvvTokenError, canContinue } = this.state;
    return<>
    <form ref={formRef} className={"cardknoxForm" + (loadedCard&&loadedCVV?"":" invisible")} onSubmit={this.handleSubmit} autoComplete="off">
      {cardTokenError?<Alert color="danger">{t("Card Error")}: {t(cardTokenError)}</Alert>:null} 
      {cvvTokenError?<Alert color="danger">{t("CVV Error")}: {t(cvvTokenError)}</Alert>:null} 
      <div className={"cardknoxFormInputs"}>
        <div className="left">
          <div className={"icon-brand mie-3 mis-0" + (cardError?" error":"")}><FontAwesomeIcon icon={cardBrand && cardBrandsCardknox[cardBrand]?cardBrandsCardknox[cardBrand].icon:cardBrandsCardknox['blank'].icon} /></div>
          <IField ref={this.iFieldCardRef} onError={this.onTokenError} onUpdate={this.onUpdate} onLoad={()=>this.displayField('card')}  onToken={this.onToken} options={{autoFormat: true,autoFormatSeparator:" ",placeholder:t("Card Number"),'iFieldstyle':this.state.iFieldstyle}} account={this.state.account} type={CARD_TYPE} />
        </div>
        <div className="right">
          <input ref={this.expInput} type="text" onChange={this.handleChange} name="exp" value={exp} placeholder={t("MM/DD")}></input>
          <IField className="hel" ref={this.iFieldCvvRef} onError={this.onTokenError} onUpdate={this.onUpdateCVV}  onLoad={()=>this.displayField('cvv')} onToken={this.onToken} options={{placeholder:t("CVV"),'iFieldstyle':this.state.iFieldstyle}} account={this.state.account} type={CVV_TYPE} />
        </div>
        </div>
      {!inlineForm?
      <div className="d-flex mt-3 mb-3">
        <Button className="btn btn-secondary btn-block btn-lg btn-cardknox" type="btn btn-secondary" disabled={!canContinue} loading={isLoading}>{this.props.paymentButtonText?t(this.props.paymentButtonText):t('Charge Card')}</Button>
      </div>
      :null}
    </form>
    </>
  }
}
export default withTranslation()(CardknoxCardForm);